export var ENTER = "enter";
export var ENTERING = "entering";
export var ENTERED = "entered";
export var EXIT = "exit";
export var EXITING = "exiting";
export var EXITED = "exited";
export var UNMOUNT = "unmount";
export var COLLAPSE_TIMEOUT = {
    enter: 250,
    exit: 200,
};
export var DEFAULT_COLLAPSE_MIN_HEIGHT = 0;
export var DEFAULT_COLLAPSE_MIN_PADDING_TOP = 0;
export var DEFAULT_COLLAPSE_MIN_PADDING_BOTTOM = 0;
export var CROSS_FADE_TIMEOUT = {
    enter: 300,
    exit: 0,
};
export var CROSS_FADE_CLASSNAMES = {
    appear: "rmd-cross-fade",
    appearActive: "rmd-cross-fade--active",
    enter: "rmd-cross-fade",
    enterActive: "rmd-cross-fade--active",
};
export var SCALE_CLASSNAMES = {
    appear: "rmd-transition--scale-enter",
    appearActive: "rmd-transition--scale-enter-active",
    enter: "rmd-transition--scale-enter",
    enterActive: "rmd-transition--scale-enter-active",
    enterDone: "",
    exit: "rmd-transition--scale-exit",
    exitActive: "rmd-transition--scale-exit-active",
};
export var SCALE_Y_CLASSNAMES = {
    appear: "rmd-transition--scale-y-enter",
    appearActive: "rmd-transition--scale-y-enter-active",
    enter: "rmd-transition--scale-y-enter",
    enterActive: "rmd-transition--scale-y-enter-active",
    enterDone: "",
    exit: "rmd-transition--scale-y-exit",
    exitActive: "rmd-transition--scale-y-exit-active",
};
export var SCALE_TIMEOUT = {
    enter: 200,
    exit: 150,
};
//# sourceMappingURL=constants.js.map